import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { Displayable, DisplayOptions, Filter } from '../../models/filter-models';
import { WaystoneFilterType } from "../../models/enums";
import { DisplayType, EquipmentTierType } from "../../models/enums";
import { MinimapIconShape, Rarity } from "../../models/enums";
import { FilterService } from '../../services/filter.service';
import { TierStyleComponent } from '../../common/tier-style/tier-style.component';
import { BaseType, Tier } from '../../models/item-data-models';
import { ItemDataService } from '../../services/item-data.service';
import { SelectComponent, SelectOptionComponent } from '../../common/select/select.component';
import { BaseComponent } from '../../common/base.component';
import { ActiveRules } from '../../services/filter-generator.service';
import { EquipmentType } from '../../models/equipment-type.enum';
import { FilterCheckboxGroupComponent } from '../../common/filter-checkbox-group/filter-checkbox-group.component';

@Component({
  selector: 'app-map-filters-poe1',
  imports: [FormsModule, FilterTitleComponent, TierStyleComponent, SelectComponent, SelectOptionComponent, FilterCheckboxGroupComponent],
  templateUrl: './map-filters-poe1.component.html',
  styleUrl: './map-filters-poe1.component.scss'
})
export class MapFiltersPoe1Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;
  @Input({ required: true }) dynamicWaystoneThresholds!: any;

  sTierWaystone!: Displayable;
  aTierWaystone!: Displayable;
  bTierWaystone!: Displayable;
  cTierWaystone!: Displayable;
  dTierWaystone!: Displayable;
  eTierWaystone!: Displayable;
  fTierWaystone!: Displayable;

  WaystoneFilterType = WaystoneFilterType;
  MinimapIconShape = MinimapIconShape;
  DisplayType = DisplayType;
  Rarity = Rarity;
  EquipmentType = EquipmentType;
  advancedMapFilters = false;

  maps: BaseType[] = [];

  constructor(private filterService: FilterService, private itemDataService: ItemDataService) {
    super();
    this.sTierWaystone = { displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.SPurple, displayTypeTierHighlightType: EquipmentTierType.Map }) };
    this.aTierWaystone = { displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.ARed, displayTypeTierHighlightType: EquipmentTierType.Map }) };
    this.bTierWaystone = { displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.BOrange, displayTypeTierHighlightType: EquipmentTierType.Map }) };
    this.cTierWaystone = { displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.CYellow, displayTypeTierHighlightType: EquipmentTierType.Map }) };
    this.dTierWaystone = { displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.DWhite, displayTypeTierHighlightType: EquipmentTierType.Map }) };
    this.eTierWaystone = { displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.EVisible, displayTypeTierHighlightType: EquipmentTierType.Map }) };
    this.fTierWaystone = { displayOptions: new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTier: Tier.FHidden, displayTypeTierHighlightType: EquipmentTierType.Map }) };

    this.maps = this.poe2 ? [] : this.itemDataService.getItemData().filter(i => i.itemType === 'Maps').flatMap(i => i.baseTypes);
  }

  toggleDynamicWaystones = () => {
    this.filter.dynamicWaystones = !this.filter.dynamicWaystones;
    if (this.filter.dynamicWaystones && !this.filter.dynamicWaystonesLevel) {
      this.filter.dynamicWaystonesLevel = 1;
    }
    if (!this.filter.dynamicWaystones && this.advancedMapFilters) {
      this.advancedMapFilters = false;
    }
    this.updateFilter();
  }

  waystoneFilterTypeChanged = () => {
    if (this.filter.waystoneFilterType === WaystoneFilterType.StaticDefault || this.filter.waystoneFilterType === WaystoneFilterType.StaticStrict) {
      this.filter.dynamicWaystonesLevel = null;
    } else if (this.filter.waystoneFilterType === WaystoneFilterType.Dynamic) {
      this.filter.dynamicWaystonesLevel = 15;
    }

    this.updateFilter();
  }

  daynamicWaystoneLevelChanged() {
    if (this.filter.dynamicWaystonesLevel && this.filter.dynamicWaystonesLevel > (this.poe2 ? 15 : 16)) {
      this.filter.dynamicWaystonesLevel = this.poe2 ? 15 : 16;
    }
    this.updateFilter();
  }

  mapTypesLowTierMinTierChanged() {
    if (this.filter.mapTypesLowTierMinTier === undefined || this.filter.mapTypesLowTierMinTier === null) this.filter.mapTypesLowTierMinTier = 14;
    else if (this.filter.mapTypesLowTierMinTier > 15) this.filter.mapTypesLowTierMinTier = 15;
    this.updateFilter();
  }


  updateFilter() {
    this.filterService.updateFilter();
  }
}
